/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DIALOG_SIZE_SM, DialogContentProps } from '@squiz/sds';
import { DialogProps } from 'libs/sds/src/Components';
import React from 'react';
import { InformationDialogContent } from '../elements/InformationDialogContent/InformationDialogContent';
import { InformationDialogContentProps } from '../elements/InformationDialogContent/InformationDialogContent.props';

export const getInformationDialogProps = ({
  id,
  urls,
}: InformationDialogContentProps): Omit<DialogProps, 'stateHandler'> => {
  return {
    classes: 'file-explorer__dialog remove-heading',
    dialogContent: {
      renderContent: (props: DialogContentProps): JSX.Element => {
        const contentProps = { ...props };
        contentProps.customProps = { id, urls } as InformationDialogContentProps;

        return <InformationDialogContent {...contentProps} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM,
    heading: '',
  };
};
